import moment from 'moment'

export function cleanCrewMemberAssignments(assignments, isForeman) {

    return assignments.map(assignment => {

        let listItem = { id: assignment.id, hours: "", overTime: "", doubleTime: "" }

        // job
        listItem['job'] = assignment.jobDay.job.name

        // date
        listItem['date'] = moment(assignment.jobDay.date).format("M/D/YYYY")

        // position
        listItem['position'] = isForeman ? 'Foreman' : 'Crew Member'

        // time
        var start = moment(`2000-01-01 ${assignment.startTime}`)
        listItem['time'] = `${start.format("hh:mm A")} - `
        
        // hours
        if(assignment.endTime) {
            var end = moment(`2000-01-01 ${assignment.endTime}`)
            const totalHours = end.diff(start, 'hours', true) - 0.5
            listItem['hours'] = totalHours
            listItem['time'] = `${listItem['time']} ${assignment.endTime ? end.format("hh:mm A") : ''}`

            // overtime
            if(totalHours > 8) {
                listItem['overTime'] = totalHours - 8
                listItem['hours'] = 8
            }

            // double time
            if(totalHours > 12) {
                listItem['doubleTime'] = totalHours - 12
                listItem['overTime'] = 4
            }
        }

        return listItem
    })
}